import React from 'react';

import { Box, Typography } from '@mui/material';
import { usePageMetadata } from 'contexts/page-metadata-context';
import styles from './logo.module.scss';

export const LogoNoLogo = () => {
  const { metadata } = usePageMetadata();
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      {metadata.avatar_url && (
        <img
          style={{
            borderRadius: '200px',
          }}
          height={52}
          width={52}
          src={metadata.avatar_url}
          alt="Profile"
        />
      )}
      <Typography className={styles.page_title_text} variant="h4">
        {metadata.title}
      </Typography>
    </Box>
  );
};
